import { apiErrorHandler } from '@/helpers/errorHandlers'

import API from '../client'

const fetchSubscriptionPlans = async (params) => {
  const route = `api/subscriptionPlans`
  return API.get(route, { params })
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(apiErrorHandler(error.response.data)))
}

const addNewSubscriptionPlan = async (data) => {
  const route = `api/subscriptionPlans`
  return API.post(route, data)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(apiErrorHandler(error.response.data)))
}

const deleteSubscriptionPlan = async (id) => {
  const route = `api/subscriptionPlans/${id}`
  return API.delete(route)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(apiErrorHandler(error.response.data)))
}

const putSubscriptionPlan = async (data) => {
  const route = `api/subscriptionPlans`
  return API.put(route, data)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(apiErrorHandler(error.response.data)))
}

export { addNewSubscriptionPlan, deleteSubscriptionPlan, fetchSubscriptionPlans, putSubscriptionPlan }
